import { ROUTES } from '../../constants/routes'

export const titles: Record<string, string> = {
  [ROUTES.SETTINGS]: 'Settings',
  [ROUTES.CLIENT_SETTINGS_NOTIFICATIONS]: 'Settings',
  [ROUTES.SETTINGS_PROFILE]: 'Settings',
  [ROUTES.SETTINGS_SECURITY]: 'Settings',
  [ROUTES.SETTINGS_DISPLAY]: 'Settings',
  [ROUTES.SETTINGS_ACCESS_TOKENS]: 'Settings',
  [ROUTES.HOMEPAGE]: 'Dashboard',
  [ROUTES.SUBMIT_REPORTING]: 'Reporting',
  [ROUTES.ACCOUNT_ACTIVITY]: 'Activity',
  [ROUTES.NOTIFICATIONS]: 'Notifications',
  [ROUTES.CLIENT_VISUALIZATIONS]: 'Analytics',
  [ROUTES.CLIENT_SUBMIT_REPORTING_PAGE]: 'Ongoing Reporting',
}
